import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3tcu7v7vc9: FaireBrandEntity = {
  token: "b_3tcu7v7vc9",
  type: "brand",
  name: "HARMONIFY",
  avatarUrl:
    "https://cdn.faire.com/fastly/735cdd1b5f06e0cf8c557a486ad97cf416e6353067f6494d61207499917a086d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/150a86b7811dc05663da28e5ea9c77e6104e1d2cbb9ad03c60c6beba041fe76a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/735cdd1b5f06e0cf8c557a486ad97cf416e6353067f6494d61207499917a086d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/150a86b7811dc05663da28e5ea9c77e6104e1d2cbb9ad03c60c6beba041fe76a.jpeg",
  location: "LAS VEGAS, NV, USA",
  minimumOrderDollars: 50,
  rating: 4.6,
  reviewCount: 81,
  isInsider: true,
  description:
    "HARMONIFY is a brand that offers you the key to a healthy and beautiful life. With our headquarters in San Francisco, we open the door to a world filled with beauty products and supplements. Guiding you in your pursuit of beauty and health, we commit to providing you with the highest quality products.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:16.986Z",
    importedBy: "entity-db-cli",
  },
};
